
  <mat-toolbar>{{"Select Job Site(S) To Add" | translate | async}}</mat-toolbar>
  <div class="DialogBoxJSL">
<div class="SelectUser">

  <!--<h4>User</h4>-->  

  <mat-form-field class="MFF">
    <mat-label>{{"Customer" | translate | async}}</mat-label>
     <mat-select [(ngModel)]="selectedCustomer" name="customer" [placeholder]="'Select Customer' | translate | async">
      <mat-option *ngFor="let option of CustomerList" [value]="option.customerId" (click)="onChangeCustomer()" >
        {{option.customerName}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</div>

<div class="UserListMain">
  <h4>{{"Job Site" | translate | async}}</h4>
  <div>
  <mat-selection-list  class="UserList" #arra1 [(ngModel)]="selectedOptions1" >
    <mat-list-option *ngFor="let item of array1" [value]="item">
      {{item.site_name}}
    </mat-list-option>
  </mat-selection-list>
  </div> 

  <div class="AddOrReBtn">
    <button mat-stroked-button class="AddBtn" (click)="AddItem()">>></button>
    <button mat-stroked-button class="RemoveBtn" (click)="RemoveItem()"><<</button>
  </div>
  
  <div>
    <mat-selection-list  class="UserList" #arra2 [(ngModel)]="selectedOptions2" >
      <mat-list-option *ngFor="let item of array2" [value]="item">
        {{item.site_name}}
      </mat-list-option>
    </mat-selection-list>
    </div>
</div>

<!--<span>userId {{userid}} userName {{usename}} </span>-->
  <div class="DialogBoxCLBtn">
    <button mat-stroked-button class="AddNewUserClAddBtn" (click) ="AddNewJobSitetoUser()">{{"Add" | translate | async}}</button>
    <button mat-stroked-button class="AddNewUserClClsBtn" (click)="DialogClose()">{{"Close" | translate | async}}</button>
  </div>

</div>